import { useEffect, useRef, useState } from 'react';

type Props = {
  initialTime: number;
};

export const useCountdown = (props: Props) => {
  const { initialTime } = props;
  const [time, setTime] = useState(initialTime);
  const startTimeRef = useRef(performance.now());
  const requestIdRef = useRef<number>();

  const updateTimer = () => {
    const currentTime = performance.now();
    const elapsedMilliseconds = currentTime - startTimeRef.current;
    const remainingTime = Math.max(0, initialTime - Math.floor(elapsedMilliseconds / 1000));
    setTime(remainingTime);

    if (remainingTime > 0) {
      requestIdRef.current = requestAnimationFrame(updateTimer);
    }
  };

  useEffect(() => {
    requestIdRef.current = requestAnimationFrame(updateTimer);
    setTime(initialTime);
    startTimeRef.current = performance.now();

    return () => {
      if (requestIdRef.current) {
        cancelAnimationFrame(requestIdRef.current);
      }
    };
  }, [props]);

  return [time];
};
